module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('VueUEditor', {
    attrs: {
      "ueditorPath": _vm.ueditorPath,
      "ueditorConfig": _vm.ueditorConfig
    },
    on: {
      "ready": _vm.ueditorReady
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-612f0b0d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UEditor/UEditor.vue
// module id = 1256
// module chunks = 0